module.exports = __webpack_public_path__ + "img/TruPath-5.bf55fd4e.jpg";